import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import "../modal.css";
import { api_path } from "../shared";
import DataView from "./BookingCancelDataView";
function BookingCancelConditionModal(props) {
  const [getBookingData, setBookingData] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    const response = await fetch(api_path + "/BC_MS_CARRIER.php?type=1");
    const data = await response.json();
    setBookingData(data);
  };
  return (
    <>
      <button onClick={handleShow} className="btn btn-clear">
        Click here
      </button>

      <Modal
        size="lg"
        className="modal"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        scrollable={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Cancel Booking cutoff criteria</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="">
            <table class="table table-bordered table-hover">
              <thead class="thead-light">
                <tr>
                  <th scope="col">CARRIER</th>
                  <th scope="col">GENERAL DAYS</th>
                  <th scope="col">REEFER DAYS</th>
                  <th scope="col">DG DAYS</th>
                </tr>
              </thead>

              <>
                {getBookingData.map((fdata) => {
                  return (
                    <DataView
                      CARRIER={fdata.CARRIER}
                      GENERAL_DAYS={fdata.GENERAL_DAYS}
                      REEFER_DAYS={fdata.REEFER_DAYS}
                      DG_DAYS={fdata.DG_DAYS}
                    />
                  );
                })}
              </>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={handleClose}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default BookingCancelConditionModal;
